import { SITE_URL } from 'env';
import ShareUrl from 'components/share-url';
import React from 'react';
import { Signer } from 'generated/credit-analysis-graphql';
import Loading from 'components/loading';
import { getLoanApplicationParams } from 'utils/utils';
import { useGetLoanQuery } from 'generated/graphql';

type AllowedDocumentsPartnerProps = {
    signer: Signer
};
const AllowedDocumentsPartner: React.FC<AllowedDocumentsPartnerProps> = ({ signer }): JSX.Element => {
    const loanApplicationId = getLoanApplicationParams();

    const { data, loading } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"network-only"
    });


    return (
        loading
            ? <Loading />
            : <>
                <div className="body-2 medium text-center mb-3">- ou -</div>
                <div className="l-documents-screen__invitation">
                    <h3 className="bold mb-3">Pedir para sócio enviar foto da identificação</h3>
                    <p className="body-2 lg:body-1 mb-5">
                        Envie o link para seu sócio enviar uma foto do próprio documento de identificação.
                        Assim que recebermos, você será avisado para continuar.
                    </p>
                    <ShareUrl
                        url={`${SITE_URL}/pedido/${data?.loanApplication.id}/documentacao/envio-documentos-socio/${signer.id}/`}
                        whatsappMessage={`Olá ${signer.name}, seu sócio ${data?.loanApplication.borrower.responsibleName}
                            solicitou que você entre nesse link para completar o pedido de empréstimo da sua empresa na Bizcapital.
                            Será necessário que você envie uma imagem de frente e verso do seu documento de identificação. Qualquer
                            dúvida entre em contato com seu sócio para melhores esclarecimentos.
                            ${`${SITE_URL}/pedido/${data?.loanApplication.id}/documentacao/envio-documentos-socio/${signer.id}/`}`}
                    />
                </div>
            </>
    );
};

export default AllowedDocumentsPartner;
